import styled from 'styled-components'

export const Detail = styled.div`
    flex: 1;
    flex-grow: ${props => props.grow ? 1 : 0};
    &:last-child:not(:first-child) {
        justify-content: flex-end;
        display: flex;
    }
`
